(function(){
    angular
        .module('appback')
        .directive('ngTipoanimal', tipoAnimal);

        tipoAnimal.$inject = ['AnimalesService','$timeout'];
        function tipoAnimal(AnimalesService,$timeout){
            return {
	            require: 'ngModel',
	            template: '<button class="btn btn-animal" ng-click="seleccionarCategoria(especie)" type="button" ng-class="{\'active\' : especie.id==ngModel}" ng-repeat="especie in categoriasEspecies" ><span class="icon [[especie.icono]]"></span><span ng-bind="especie.nombre"></span></button>',
		          scope: {
                  ngModel : '=',
                  animal: '='
              },
            link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {
                    scope.categoriasEspecies = [];
                    scope.seleccionado = ngModel.$viewValue;
                    scope.init = function(){
                      AnimalesService.getCategoriasEspecies(function(data){
                        scope.categoriasEspecies = data.categoriasEspecies;
                        var valor = ngModel.$viewValue;
                        if(valor==0){
                          scope.seleccionarCategoria(data.categoriasEspecies[0]);
                        }
                      })
                    }
                    scope.seleccionarCategoria = function(especie){
                      scope.animal.especie = "";
                      scope.animal.raca = "";
                      console.log(scope);
                      scope.ngModel = especie.id;
                    }
                    scope.init();
		            });
		        }
          }
      }
})();